// Table type constants
export const TABLE_TYPES = {
  TEMPLATE: 'template',
  CUSTOM: 'custom'
};

// Column data types
export const COLUMN_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  TEXTAREA: 'textarea',
  CHECKBOX: 'checkbox',
  CHECKLIST: 'checklist',
  CELL_CHECKLIST: 'cell_checklist',
  ACTIONS: 'actions'
};

// Column properties
export const COLUMN_PROPERTIES = {
  READONLY: 'readonly',
  REQUIRED: 'required'
};

// Permission levels
export const PERMISSION_LEVELS = {
  RESTRICTED: 3
};

// Default form values for template tables
export const DEFAULT_TEMPLATE_ROW = {
  equipment: "",
  ifb: "",
  ifc: "",
  notes: "",
  ifr: "",
};

// Table column definitions for template tables
export const TEMPLATE_COLUMNS = [
  { key: 'equipment', label: 'Equipment' },
  { key: 'ifb', label: 'IFB' },
  { key: 'ifc', label: 'IFC' },
  { key: 'ifr', label: 'IFR' },
  { key: 'notes', label: 'Notes' }
];

// Messages
export const MESSAGES = {
  ERRORS: {
    NO_TABLE_NAME: "Please enter a table name",
    NO_COLUMNS: "Please add at least one column",
    FETCH_TABLES: "Unable to fetch tables.",
    FETCH_DATA: "Unable to fetch data for the selected table. Check console for details.",
    DELETE_ROW: "Error deleting row. Check console for details.",
    SAVE_ROW: "Error saving row. Check console for details.",
    CREATE_TABLE: "Error creating table. Check console for details.",
    REFRESH_TABLES: "Error refreshing tables after creation."
  },
  SUCCESS: {
    TABLE_DELETED: "Successfully deleted custom table",
    TABLE_DELETED_CASCADE: "Successfully deleted custom table and related records"
  }
};
